<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{ toggled: $sidebar.showSidebar }">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
      <!--<a class="navbar-brand" href="#pablo">
        {{ $route.name }}
      </a>-->
    </div>
    <button
      @click="toggleNavbar"
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navigation"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">
      <ul class="navbar-nav">
        <!--<li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="now-ui-icons media-2_sound-wave"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons location_world"
          title="Idioma"
        >
          <a class="dropdown-item" href="#">Español</a>
          <a class="dropdown-item" href="#">English</a>
        </drop-down>-->
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons location_world"
          :title="$t('app.general.language') + ' | ' + lang"
        >
          <button class="dropdown-item" @click="changeLanguage('es')">
            Español
          </button>
          <button class="dropdown-item" @click="changeLanguage('en')">
            English
          </button>
        </drop-down>

        <!--<li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="now-ui-icons users_single-02"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>-->
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons users_single-02"
          :title="$t('app.nav_bar.admin.account.title')"
        >
          <!--<a class="dropdown-item" href="{{  }}">Cerrar sesión</a>-->
          <a class="dropdown-item" @click="closeSesion" href="#">{{
            $t("app.nav_bar.admin.account.close_session")
          }}</a>
        </drop-down>

        <div v-if="this.nc > 0">
          <el-badge  :value="this.nc" class="item">
            <router-link class="nav-item" tag="li" to="/admin/notificaciones_web">
              <a class="nav-link">
                <i class="now-ui-icons ui-1_bell-53"></i>
              </a>
            </router-link>
          </el-badge>
        </div>
        <div v-else>
          <router-link class="nav-item" tag="li" to="/admin/notificaciones_web">
            <a class="nav-link">
              <i class="now-ui-icons ui-1_bell-53"></i>
            </a>
          </router-link>
        </div>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    Navbar,
    NavbarToggleButton
  },
  computed: {
    ...mapState(["lang"]),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }, 
    nc() {
       return this.$store.state.not_count;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false
    };
  },
  methods: {
    ...mapMutations({
      setLang: "SET_LANG"
    }),
    changeLanguage(value) {
      this.$router.go(0);
      this.setLang(value);
      this.$root.$i18n.locale = value;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    closeSesion() {
      this.$router.push({
        name: "Logout"
      });
    }
  }, 
  created() {
    console.log(this.nc)
    console.log(this.$store.state.not_count) 
  }
};
</script>
<style>

.el-badge__content.is-fixed { 
  top: 10px !important;
  right: 15px !important;
  } 

</style>
